import {useState} from 'react';
import {registrationAPI} from '../../services/RegistrationServices';
import {normalizeApiError} from '../../common/apiErrors';

export function useRegistrationLegal() {
    // Polish is the contract language; interface translations do not change its version.
    const query = registrationAPI.useGetLegalDocumentsQuery('pl', {refetchOnMountOrArgChange: true});
    const [acceptedVersion, setAcceptedVersion] = useState('');
    const [updated, setUpdated] = useState(false);
    const dpa = query.currentData?.find(document => document.code === 'data-processing-agreement');
    const terms = query.currentData?.find(document => document.code === 'terms-of-service');
    const versionKey = JSON.stringify([dpa?.id, terms?.id]);
    const ready = !!terms?.content && !!dpa?.content && !query.isFetching && !query.isError;
    const accepted = ready && acceptedVersion === versionKey;
    const handleError = (error: unknown) => {
        const problem = normalizeApiError(error);
        if (problem.status !== 409 || problem.code !== 'legal_documents.version_unavailable') return false;
        setAcceptedVersion('');
        setUpdated(true);
        void query.refetch();
        return true;
    };
    return {dpa, terms, accepted, ready, updated, loading: query.isFetching,
        setAccepted: (value: boolean) => setAcceptedVersion(value && ready ? versionKey : ''),
        retry: () => query.refetch(), handleError,
        actions: accepted ? [terms, dpa].filter((document): document is NonNullable<typeof document> => !!document)
            .map(document => ({documentVersionId: document.id, action: 'Accepted' as const})) : []};
}
